import { Component, Input, OnInit, inject } from '@angular/core';
import { keyedStatusOptions } from 'app/core/options/provider-status.opts';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { MinimalProvider } from 'app/core/models/minimal-provider.model';

import { CopyToClipboardComponent } from '../copy-to-clipboard/copy-to-clipboard.component';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { BlankValueDashComponent } from '../blank-value-dash/blank-value-dash.component';

@Component({
    selector: 'app-prescriber-name',
    templateUrl: './prescriber-name.component.html',
    styleUrls: ['./prescriber-name.component.scss'],
    imports: [CopyToClipboardComponent, RouterLinkActive, RouterLink, FaIconComponent, BlankValueDashComponent]
})
export class PrescriberNameComponent implements OnInit {
  private authService = inject(AuthenticationService);

  @Input() provider: MinimalProvider;
  @Input() linkToProvider = false;
  @Input() showSpecialtiesDetails = false;

  keyedStatusOptions = keyedStatusOptions;
  canViewProvider = false;

  ngOnInit() {
    this.canViewProvider = this.authService.isCaptureAdminUser;
  }

  get hasName() {
    return this.provider.fullName.trim().length > 0;
  }

  get hasSpecialtiesInfo() {
    return this.showSpecialtiesDetails && this.provider.displaySpecialty.trim().length > 0;
  }
}
